'use strict';

class PasswordController {
  constructor($rootScope,
              $scope,
              $filter,
              utils,
              $state,
              webcore,
              OrganizationService,
              UsersService,
              I18nService,
              ToastsService) {
    let $t = $filter('translate');

    $scope.availableLanguages = [];
    $scope.orgId = $state.params && $state.params.orgId;
    $scope.email = $state.params && $state.params.email;
    $scope.userId = $state.params && $state.params.userId;
    $scope.success = false;
    $scope.loading = false;

    angular.extend($scope, {
      onLanguageDropdownSelectionChange: onLanguageDropdownSelectionChange,
      onRestorePasswordButtonClick: onRestorePasswordButtonClick
    });

    init();

    function init() {
      initLanguage();

      $('.ui.form').form({
        inline: true,
        fields: {
          username: {
            identifier: 'email',
            rules: [
              {
                type: 'email',
                prompt: $t('prompt.email.valid')
              }
            ]
          }
        }
      });

      if ($scope.orgId) {
        getOrganizationInfo();
        getOrgProperties();
      }

      $scope.$watch('orgId', () => {
        utils.getOrganizationLogoPath($scope.orgId)
          .then(logoPath => {
            $scope.orgLogoUrl = logoPath;
          });
      });
    }

    function initLanguage() {
      $scope.availableLanguages = I18nService.getLocalesList();
      $scope.selectedLng = I18nService.getLocale();
      $scope.selectedLngIndex = $scope.availableLanguages.findIndex(l => l.code === $scope.selectedLng.code);

      $('#drop-lang').dropdown({
        onChange: function(value, text) {
          $scope.$applyAsync(() => {
            $scope.selectedLngIndex = value;
            let lng = $scope.availableLanguages[value];
            onLanguageDropdownSelectionChange(lng);
          });
        }
      });
    }

    function onLanguageDropdownSelectionChange(lng) {
      I18nService.setLocale(lng);
      $scope.selectedLng = I18nService.getLocale();
    }

    function onRestorePasswordButtonClick() {
      // Prevent doubling of send email service trigger
      if ($scope.loading || $scope.success) {
        return;
      }
      if (!$('.ui.form').form('is valid')) {
        return;
      }
      sendRestorePasswordEmail();
    }

    function sendRestorePasswordEmail() {
      $scope.loading = true;
      UsersService.resetPassword($scope.email)
        .then(() => {
          $scope.loading = false;
          $scope.success = true;
          $scope.emailSentSuccessMessage = utils.isEmail($scope.email)
            ? $t('form.forgot-success', { email: $scope.email })
            : $t('form.forgot-success-no-email');
          ToastsService.success(null, $t('common.send-email-success'));
        }, (err) => {
          $scope.success = false;
          $scope.loading = false;
          $scope.errorMessage = err.resultCodeMessage || err.resultCodeDesc || $t('errors.forgot-error-ambient');
          $scope.emailSentSuccessMessage = void 0;
          ToastsService.error(null, $t('common.send-email-error'));
        });
    }

    function getProperties(orgProperties) {
      $scope.orgBgColorVal = getPropertyByColorName(orgProperties, 'tmp_bg');
      $scope.orgPrimaryColorVal = getPropertyByColorName(orgProperties, 'tmp_primary');
      $scope.orgSecondaryColorVal = getPropertyByColorName(orgProperties, 'tmp_secondary');
      updatePageCss();
    }

    function getPropertyByColorName(orgProperties, colorName) {
      return utils.getPropertyByName(orgProperties, colorName, true);
    }

    function updatePageCss() {
      if ($scope.orgBgColorVal) {
        $('body').css('background', $scope.orgBgColorVal);
      }
      if ($scope.orgPrimaryColorVal) {
        $('.ui.primary.button').css('background', $scope.orgPrimaryColorVal);
        $('#maestro-signin-divider').css('background', $scope.orgPrimaryColorVal);
      }
    }

    function getOrganizationInfo() {
      return OrganizationService.getOrganization($scope.orgId)
        .then((data) => {
          if (data.organizations && data.organizations.length > 0) {
            $scope.orgInfo = data.organizations[0];
            $scope.orgName = $scope.orgInfo.name;
          }
        });
    }

    function getOrgProperties() {
      return OrganizationService.getObjectsAndProperties($scope.orgId)
        .then((data) => {
          $scope.orgProperties = data.organizationObjects;
          getProperties($scope.orgProperties);
        });
    }
  };
}

export default angular
  .module('password.controller', [])
  .controller('PasswordController', PasswordController)
  .name;
